import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { TextField } from "@gemini/ui";
import { Controller } from "react-hook-form";
import { streetInputTestId } from "./constants";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const StreetInput = ({ control, required }) => {
    const { t } = useI18n();
    const isPreviewMode = useIsPreviewMode();
    return (_jsx(Controller, { name: "street", control: control, defaultValue: "", render: ({ field, fieldState: { error } }) => (_jsx(TextField, Object.assign({}, field, { isFullWidth: true, hasNecessityIndicator: required, testId: streetInputTestId, label: t("contact.form.street"), error: error === null || error === void 0 ? void 0 : error.message, isDisabled: isPreviewMode }))) }));
};
